import React from "react";

// Canonical chrome-stripping player vars, shared by BOTH the plain-iframe embed
// below and the IFrame Player API player in FeedItem (Watch feed). Single source
// of truth so the two paths can never drift. NOTE: no `loop`/`playlist` here —
// setting playlist to loop a single video gives the player a *playlist context*,
// which is what makes YouTube render the previous/next skip arrows. Looping is
// done instead by listening for the ENDED state and seeking back to 0.
export const YT_CHROME_VARS = {
  rel: 0,            // related videos limited to our own channel
  iv_load_policy: 3, // no annotations
  modestbranding: 1, // deprecated/no-op but harmless
  playsinline: 1,
  fs: 0,
  disablekb: 1,
};

// One shared YouTube embed for every standalone context (not the Watch feed,
// which uses the IFrame Player API with our own controls in FeedItem). Uses the
// privacy-enhanced youtube-nocookie domain. Native controls stay ON by default
// because these contexts (purchases, shop, press, featured) have no custom UI.
// The title/channel/logo that reappear on hover/pause cannot be removed by
// parameter and are left alone (covering them violates YouTube's terms).
export const YouTubeEmbed = ({ videoId, title = "", autoplay = false, controls = true, className = "w-full h-full", style, testid }) => {
  if (!videoId) return null;
  const params = new URLSearchParams({
    ...Object.fromEntries(Object.entries(YT_CHROME_VARS).map(([k, v]) => [k, String(v)])),
    controls: controls ? "1" : "0",
  });
  if (autoplay) { params.set("autoplay", "1"); params.set("mute", "1"); }
  return (
    <iframe
      title={title}
      src={`https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`}
      className={className}
      style={{ border: 0, ...(style || {}) }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      data-testid={testid}
    />
  );
};

export default YouTubeEmbed;
